<template>
  <v-dialog
    v-model="open"
    transition="dialog-bottom-transition"
    max-width="fit-content"
    @click:outside="close"
    @keydown.esc="close"
    content-class="sc-modal sc-modal--sm"
  >
    <v-card flat class="sc-modal__card">
      <v-btn icon small class="sc-modal__close" @click="close">
        <v-icon size="18">mdi-close</v-icon>
      </v-btn>

      <div class="sc-modal__header sc-modal__header--divided">
        <v-icon size="20" class="mr-2" color="text_secondary">mdi-account-circle</v-icon>
        <div>
          <span class="sc-modal__title">Foto do perfil</span>
        </div>
      </div>

      <div class="modal-foto-perfil-content">
        <img
          v-if="urlFotoPerfil && !hasError"
          :src="urlFotoPerfil"
          alt="Avatar"
          class="modal-foto-perfil-img"
          @error="hasError = true"
        />
        <div v-else class="sc-empty-state modal-foto-perfil-error">
          <img src="@/assets/User.png" alt="Avatar" class="mb-3" style="width: 120px; height: 120px; object-fit: contain; opacity: 0.5;" />
          <span class="sc-empty-state__title">Foto indisponível</span>
          <span class="sc-empty-state__subtitle">O link do avatar está quebrado ou expirado</span>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    urlFotoPerfil: String,
    dialog: { default: false, type: Boolean },
  },
  data() {
    return {
      hasError: false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
  computed: {
    open: {
      get() {
        return this.dialog;
      },
      set(value) {
        if (!value) this.$emit("close");
      },
    },
  },
  watch: {
    urlFotoPerfil() {
      this.hasError = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-foto-perfil-content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.modal-foto-perfil-img {
  min-width: 280px;
  min-height: 280px;
  max-width: 500px;
  max-height: 500px;
  border-radius: var(--sc-radius-lg);
  object-fit: contain;
}

.modal-foto-perfil-error {
  width: 320px;
}
</style>
